import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Alert
} from '@mui/material';
import api from '../services/api';
import MarcaForm from './MarcaForm';
import MarcaList from './MarcaList';

function MarcaModal({ open, onClose, onMarcaSelecionada }) {
  const [marcas, setMarcas] = useState([]);
  const [editingMarca, setEditingMarca] = useState(null);
  const [error, setError] = useState('');

  const fetchMarcas = () => {
    api.get('/marcas')
      .then(response => {
        setMarcas(response.data);
      })
      .catch(err => {
        console.error("Erro ao buscar marcas:", err);
        setError('??o foi possivel carregar as marcas.');
      });
  };

  useEffect(() => {
    if (open) {
      fetchMarcas();
      setError('');
      setEditingMarca(null);
    }
  }, [open]);

  const handleSave = (marcaData) => {
    const apiCall = marcaData.id
      ? api.put(`/marcas/${marcaData.id}`, marcaData)
      : api.post('/marcas', marcaData);

    apiCall
      .then((response) => {
        setEditingMarca(null);
        fetchMarcas(); // Refresh a lista
        // Se for uma nova marca, chama o callback para selecionar no formulario de veiculo
        if (!marcaData.id && onMarcaSelecionada) {
            const novaMarcaId = response.data.id;
            onMarcaSelecionada(novaMarcaId);
        }
      })
      .catch(err => {
        console.error("Erro ao salvar marca:", err);
        setError(err.response?.data || 'Erro ao salvar marca.');
      });
  };

  const handleDelete = (id) => {
    if (window.confirm('Tem certeza que deseja deletar esta marca?')) {
      api.delete(`/marcas/${id}`)
        .then(() => {
          fetchMarcas(); // Refresh a lista
        })
        .catch(err => {
          console.error("Erro ao deletar marca:", err);
          setError(err.response?.data || 'Erro ao deletar marca.');
        });
    }
  };

  const handleEdit = (marca) => {
    setEditingMarca(marca);
  };

  const handleCancelEdit = () => {
    setEditingMarca(null);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Gerenciar Marcas de Veiculos</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" onClose={() => setError('')}>{error}</Alert>}
        <Box sx={{ my: 2 }}>
          <MarcaForm
            onSave={handleSave}
            initialData={editingMarca}
            onCancel={handleCancelEdit}
          />
        </Box>
        <MarcaList
          marcas={marcas}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default MarcaModal;

